import { css } from '@emotion/css';
import styled from '@emotion/styled';
import { Space, Badge, Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useNetwork, useRequest } from 'ahooks';
import { stat, getStatBody } from 'services/api/review';
import { useEffect } from 'react';
import { noop } from 'lodash-es';

import { useReviewStat, useSetReviewStat } from './useReviewStatState';

export const ReviewNav = () => {
  const { t } = useTranslate();
  const { totalNum } = useReviewStat();
  const setReviewStat = useSetReviewStat();
  const { online } = useNetwork();

  const { run: startPollingStat, cancel: stopPollingStat } = useRequest(
    () => stat(getStatBody()).then(setReviewStat),
    {
      pollingInterval: 15 * 1000,
      manual: true,
      // pollingWhenHidden: false,
      onError: noop,
    },
  );

  useEffect(() => {
    if (online) {
      startPollingStat();
    } else {
      stopPollingStat();
    }

    return () => {
      stopPollingStat();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [online]);

  return (
    <div>
      <Space>
        {t('scene.workspace.title.review')}
        <Badge count={totalNum} overflowCount={9999} style={{ background: '#FF7E00' }} />
      </Space>
      <Tooltip
        overlayClassName={tooltipOverlayClassName}
        title={
          <div>
            <div>{t('review.红点是您负责的店铺中符合以下任一条件的总数：')}</div>
            <div>{t('review.Shopee：近2天内1～3星的待处理和处理中评价数量')}</div>
            <div>
              Lazada：
              {t('review.Lazada评分tips')}
            </div>
          </div>
        }
      >
        <Info />
      </Tooltip>
    </div>
  );
};

const tooltipOverlayClassName = css`
  max-width: 380px;
`;

const Info = styled(InfoCircleOutlined)`
  margin: 4px;
  color: #979797;
`;
